<template>
    <div class="card">
        <div class="top">
            <p id="title">{{ title }}</p>
        </div>
        <div class="middle">
            <img src="./asicshome.png" alt="">
            <img src="./asicshome.png" alt="" v-if="counter > 1">
            <div class="last">
                <div class="centered" v-if="counter > 3">+{{counter -3}}</div>
                <div class="centeredbackground" v-if="counter > 3"></div>
                <img src="./asicshome.png" alt="" v-if="counter > 3">
                <img src="./asicshome.png" alt="" v-if="counter === 3">
            </div>
            
        </div>
        <div class="bottom">
            <p>{{ createdBy }}</p>
            <p>{{ added }}</p>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        counter: function() {
            return this.heatmaps.length
        }
    },
    props: ['title', 'createdBy', 'added','heatmaps'],
    data() {
        return {}
    }
}
</script>

<style scoped lang="scss">
.card {
    background-color: white;
    padding: 15px;
    width: 250px;
    border-radius: 6px;
    margin: 10px 0;
    border: 3px solid white;
    cursor: pointer;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
}

.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  z-index: 3;
  font-weight: 600;
}

.centeredbackground {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(99, 99, 131, 0.7);
  width: 100%;
  height: 100%;
  border-radius: 4px;
}

#title {
    font-size: 14pt;
    font-weight: 600;
    margin-bottom: 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 100%;
}

.middle {
    display: flex;
    gap: 5px;
    justify-content: space-between;
    position: relative;

    .last {
        position: relative;
        width: 65px;
        height: 65px;
    }

    img {
        height: 65px;
        width: 65px;
        object-fit: cover;
        border: 1.5px solid #C4C4C4;
        border-radius: 4px;
    }
}

.bottom {
    margin-top: 10px;
    
    p {
        font-size: 10pt;
    }
}
</style>